import React from 'react';
import qs from 'qs';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Redirect } from 'react-router-dom';
import Link from 'Components/Link';

import ReactGA from 'react-ga';
import * as usersActions from '../store/users/actions';
import * as reducers from '../store/reducers';

import ContentFrame from 'Components/ContentFrame';
import FreeTrialHeader from 'Containers/FreeTrialHeader/FreeTrialHeader';
import Form from 'Components/Form';
import Loading from 'Components/Loading';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import FormNote from 'Components/FormNote';
import { ROUTES } from 'Settings/route-strings';

class FreeTrial extends React.Component {
  constructor(props) {
    super(props);
    this.licenseMap = {
      school: 'SELF_SERVICE_TRIAL_SCHOOL',
      homeschool: 'SELF_SERVICE_TRIAL_HOMESCHOOL',
      classroom: 'SELF_SERVICE_TRIAL_CLASSROOM',
    };
  }

  componentDidMount() {
    if (typeof fbq !== 'undefined') fbq('track', 'Lead');

    if (this.props.source === 'teachervision') {
      ReactGA.set({
        campaignName: '201903_teachervision',
        campaignSource: 'teachervision',
        campaignMedium: 'newsletter',
      });
    }
  }

  componentDidUpdate() {
    // Check to see if we have an active user and send them on their way.
    if (this.props.activeUser) {
      if (typeof fbq !== 'undefined') fbq('track', 'CompleteRegistration');
    }
  }

  render() {
    const { activeUser, tokenIsActive, location, source } = this.props;
    if (activeUser) return <Redirect to={ROUTES.EXPLORE} />;
    if (tokenIsActive) return <Loading />;

    const sign_in_link = (
      <Link to={ROUTES.SIGN_IN} className="u-text-link">
        <ConnectedFormattedMessage id="form.note.freeTrial.sign_in_link" />
      </Link>
    );
    const formNote = (
      <FormNote
        text={
          <strong>
            <ConnectedFormattedMessage
              id="form.note.freeTrial.text"
              values={{
                sign_in_link,
              }}
            />
          </strong>
        }
      />
    );
    const licenseType =
      location.state && location.state.licenseType
        ? location.state.licenseType
        : 'school';

    const initialFieldSettings = {
      licenseType: {
        value: this.licenseMap[licenseType] || this.licenseMap.school,
      },
    };

    if (source) initialFieldSettings.source = { value: source };

    return (
      <main className="Page__content">
        <ContentFrame pageType="transactional" size="medium">
          <FreeTrialHeader licenseType={licenseType} source={source} />
          <Form
            type="freeTrial"
            id="freeTrial"
            formStyle="acceptTeacherInvitation"
            messagePosition="fixed-top"
            initialFieldSettings={initialFieldSettings}
            submitButtonType="primary"
            formNote={formNote}
          />
        </ContentFrame>
      </main>
    );
  }
}

const mapStateToProps = (state, { location, match: { params } }) => {
  const queryObj = qs.parse(location.search, { ignoreQueryPrefix: true });
  const source = queryObj.source || params.source;

  return {
    activeUser: reducers.getActiveUser(state),
    tokenIsActive: state.users.auth.token !== null,
    source,
  };
};

export default withRouter(connect(mapStateToProps, usersActions)(FreeTrial));
